<template>
  <PButton
    rounded
    class="bg-white!"
    severity="secondary"
    variant="outlined"
    @click="(event) => togglePopover(event)"
    data-test="button-settings"
  >
    <template #icon>
      <FontAwesomeIcon
        v-if="!loading"
        :icon="['far', 'ellipsis']"
        size="lg"
      />
      <FontAwesomeIcon
        v-else
        :icon="['far', 'spinner']"
        size="lg"
        spin
      />
    </template>
  </PButton>

  <Popover
    ref="popover"
    :pt="{ content: '!p-0 !m-0' }"
  >
    <div
      class="flex flex-col gap-1 py-1"
      @click="closePopover"
    >
      <slot />
    </div>
  </Popover>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  data_test: { type: String, default: '' },
  loading: { type: Boolean, default: false },
});

const popover = ref(null);

const togglePopover = (event) => {
  popover.value.toggle(event);
};

const closePopover = () => {
  popover?.value?.toggle(false);
};
</script>
